import { render, staticRenderFns } from "./transferAdd.vue?vue&type=template&id=674f5dc6&scoped=true&"
import script from "./transferAdd.vue?vue&type=script&lang=js&"
export * from "./transferAdd.vue?vue&type=script&lang=js&"
import style0 from "./transferAdd.vue?vue&type=style&index=0&id=674f5dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674f5dc6",
  null
  
)

export default component.exports